import React from 'react'
import { useTranslation } from 'react-i18next'

import { TrNotFound as BaseTr } from '@makyoapp/makyo-ui'

export function TrNotFound({ colSpan, children }: { colSpan: number; children?: React.ReactNode }) {
  const { t } = useTranslation()
  return <BaseTr colSpan={colSpan}>{children || t('No record found')}</BaseTr>
}
